var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6927 9.0978L17.9022 5.3073C17.7048 5.1113 17.4381 5.0007 17.1602 5H9.05C8.4704 5 8 5.4704 8 6.05V20.75C8 21.3296 8.4704 21.8 9.05 21.8H20.7924C21.6927 21.8 22 21.3645 22 20.75V9.8398C22.0007 9.5612 21.8901 9.2945 21.6927 9.0978Z",
    fill: "#10F0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5949 4L12.9022 2.3073C12.7048 2.1113 12.4381 2.0007 12.1602 2H4.05C3.4704 2 3 2.4704 3 3.05V17.75C3 18.3296 3.4704 18.8 4.05 18.8H7V6.05C7 4.91812 7.91812 4 9.05 4H14.5949Z",
    fill: "#0EC78A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "invoice-dollar-sign",
    d: "M15.3757 14.7281L13.0167 13.8461C12.3573 13.5318 11.9562 12.8472 12.0038 12.1185C11.9975 11.2015 12.6926 10.4308 13.6061 10.344C13.6915 10.3307 13.7538 10.2572 13.7538 10.1711V9.7C13.7538 9.3136 14.0674 9 14.4538 9C14.8402 9 15.1538 9.3136 15.1538 9.7V10.1375C15.1538 10.2341 15.2322 10.3125 15.3288 10.3125H16.2038C16.5902 10.3125 16.9038 10.6261 16.9038 11.0125C16.9038 11.3989 16.5902 11.7125 16.2038 11.7125H14.0163C13.4038 11.7125 13.4038 12.0177 13.4038 12.1185C13.3926 12.2725 13.4381 12.4244 13.5319 12.5469L15.8909 13.4289C16.5517 13.7439 16.9528 14.4299 16.9038 15.16C16.908 16.0763 16.2136 16.8442 15.3015 16.931C15.2161 16.9443 15.1538 17.0178 15.1538 17.1039V17.575C15.1538 17.9614 14.8402 18.275 14.4538 18.275C14.0674 18.275 13.7538 17.9614 13.7538 17.575V17.1375C13.7538 17.0409 13.6754 16.9625 13.5788 16.9625H12.7038C12.3174 16.9625 12.0038 16.6489 12.0038 16.2625C12.0038 15.8761 12.3174 15.5625 12.7038 15.5625H14.8913C15.5038 15.5625 15.5038 15.2573 15.5038 15.1565C15.515 15.0025 15.4695 14.8506 15.3757 14.7281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActive);
export default __webpack_public_path__ + "static/media/invoice-active.16e48c9a577c2859e666d60f783e524a.svg";
export { ForwardRef as ReactComponent };